import { inject, Injectable, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  AuthStatePersistenceService,
  isKeyInvalid,
  Product,
  ProductActions,
  ProductLoadingService,
} from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GgProductLoadingService extends ProductLoadingService implements OnInit, OnDestroy {
  protected productsLoadedLoggedInLoggedOutState: {
    [code: string]: { [scope: string]: boolean };
  } = {};

  protected productsLoadedWhileLoggedIn: {
    [code: string]: { [scope: string]: boolean };
  } = {};

  private authStatePersistenceService = inject(AuthStatePersistenceService);
  private currentUrl: string | undefined;
  private routerSubscription$ = Subscription.EMPTY;

  ngOnInit(): void {
    const router = inject(Router);

    this.routerSubscription$ = router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      if (this.currentUrl !== router.url && this.authStatePersistenceService.isUserLoggedIn()) {
        this.productsLoadedWhileLoggedIn = {};
      }

      this.currentUrl = router.url;
    });
  }

  ngOnDestroy(): void {
    this.routerSubscription$.unsubscribe();
  }

  override get(productCode: string, scopes: string[]): Observable<Product> {
    isKeyInvalid(productCode);

    scopes = this.loadingScopes.expand('product', scopes);

    this.initProductScopes(productCode, scopes);
    /**
     * LUFC: We need to check if the product is already loaded in the store
     * and if the user is logged in or not. If the product is already loaded
     * and the user is logged in, we need to load the product again.
     *
     * If the product is already loaded and the user is logged in,
     * we need to load the product again, because of the price change.
     */
    this.initProductLoadedLoggedInLoggedOutStateAndPreviousProduct(productCode, scopes);

    return this.products[productCode][this.getScopesIndex(scopes)];
  }

  protected initProductLoadedLoggedInLoggedOutStateAndPreviousProduct(productCode: string, scopes: string[]) {
    if (!this.productsLoadedLoggedInLoggedOutState[productCode]) {
      this.productsLoadedLoggedInLoggedOutState[productCode] = {};
    }

    if (!this.productsLoadedWhileLoggedIn[productCode]) {
      this.productsLoadedWhileLoggedIn[productCode] = {};
    }

    for (const scope of scopes) {
      if (
        this.productsLoadedLoggedInLoggedOutState[productCode][scope] !== undefined &&
        (this.productsLoadedLoggedInLoggedOutState[productCode][scope] !==
          this.authStatePersistenceService.isUserLoggedIn() ||
          !this.productsLoadedWhileLoggedIn[productCode][scope])
      ) {
        this.store.dispatch(new ProductActions.LoadProduct(productCode, scope));
      }

      this.productsLoadedLoggedInLoggedOutState[productCode][scope] = this.authStatePersistenceService.isUserLoggedIn();
      this.productsLoadedWhileLoggedIn[productCode][scope] = true;
    }
  }
}
